import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import { Toast, Checkbox, Dialog } from 'vant'

Vue.config.productionTip = false

Vue.use(Toast).use(Checkbox).use(Dialog)

// router.beforeEach((to, from, next) => {
//   console.log(to)
//   next()
// })

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
